module.exports = __webpack_public_path__ + "img/box-show.964b26f4.png";